import { useI18n } from '@app-velocity/i18n';
import { StopIcon } from '@app-velocity/icons';

import {
  useScenarioDetailsContext,
  useUserSimulationControl,
} from '@app-velocity/modules/scenarios';

import { ActionButton } from '../ActionButton';
import { useSimulationWidgetContext } from '../../../../../../hooks/useSimulationWidgetContext';

export const ActionStop = () => {
  const { t } = useI18n();
  const { stop, stopExtended } = useUserSimulationControl();
  const { scenario } = useScenarioDetailsContext();
  const { latestReview, workspaceId } = useSimulationWidgetContext();

  const handleStop = () => {
    if (!workspaceId || !scenario || !latestReview) return;

    if (latestReview.type === 'SINGLE') {
      stop(
        workspaceId,
        scenario.id!,
        scenario.shareToken!,
        latestReview.reviewId!
      );
    } else {
      stopExtended(
        workspaceId,
        scenario.id!,
        scenario.shareToken!,
        latestReview.reviewId!
      );
    }
  };

  return (
    <ActionButton onClick={handleStop}>
      {t('prototypes:stop_simulation')} <StopIcon />
    </ActionButton>
  );
};
